import React from 'react';
import CustomModal from 'components/DesignSystems/New/CustomModal';

export const ResourceTotalModal = ({
  resourceTotal,
  showModal,
  setShowModal,
}: {
  resourceTotal: {
    [resourceName: string]: { have: number; need: number; required: number };
  };
  showModal: boolean;
  setShowModal: (show: boolean) => void;
}) => {
  return (
    <CustomModal
      heading="Resource Totals"
      show={showModal}
      onClose={() => {
        setShowModal(false);
      }}
      saveButton="OK"
      onConfirm={() => {
        setShowModal(false);
      }}
      modalStyle={{ '--bs-modal-width': '50vw' } as React.CSSProperties}
    >
      <div style={{ overflowX: 'auto' }}>
        <table className="table table-striped">
          <thead>
            <tr>
              <th></th>
              {Object.entries(resourceTotal).map(([resourceName]) => (
                <th key={resourceName}>{resourceName}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Total Resources Required</td>
              {Object.entries(resourceTotal).map(([_, totals]) => (
                <td key={_.toString() + '-required'}>{totals.required}</td>
              ))}
            </tr>
            <tr>
              <td>Total Resources on Hand</td>
              {Object.entries(resourceTotal).map(([_, totals]) => (
                <td key={_.toString() + '-have'}>{totals.have}</td>
              ))}
            </tr>
            <tr>
              <td>Total Resources Needed</td>
              {Object.entries(resourceTotal).map(([_, totals]) => (
                <td key={_.toString() + '-need'}>{totals.need}</td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </CustomModal>
  );
};
